/* Deactivated */

import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { affinityVariableEPlusContent } from './affinityVariableEPlus';
import { DETAILS_CONTENT_KEYS, IPlanContent, KeyDetailsItem } from '../typings/planContent.types';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const pwcKeyDetails =
  affinityVariableEPlusContent?.content?.keyDetails?.defaultState?.defaultFuel.filter(
    (item: KeyDetailsItem) => item.contentKey !== DETAILS_CONTENT_KEYS.GreenOptions
  ) ?? [];

export const pwcAffinityVariableEPlusContent: IPlanContent = {
  test: createPlanNameMatcher([
    'Origin PwC Affinity Variable',
    'Origin PwC Affinity Variable - 100% GreenPower incl in your plan',
    'Origin PwC Affinity Variable - 100% carbon neutral natural gas incl in your plan',
  ]),
  content: {
    ...affinityVariableEPlusContent.content,
    keyDetails: {
      defaultState: {
        defaultFuel: pwcKeyDetails,
        dual: [
          ...pwcKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue:
              '100% GreenPower and Origin Go Zero Natural Gas carbon offset add-on included in this plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription:
              '100% GreenPower and Origin Go Zero Natural Gas carbon offset add-on included in this plan',
          },
        ],
        electricity: [
          ...pwcKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: '100% GreenPower included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription: '100% GreenPower included in the plan',
          },
        ],
        gas: [
          ...pwcKeyDetails,
          {
            contentKey: DETAILS_CONTENT_KEYS.Addons,
            contentValue: 'Origin Go Zero Natural Gas carbon offset add-on included in the plan',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Addons),
            contentDescription:
              'Origin Go Zero Natural Gas carbon offset add-on included in the plan',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: [...dualKeyDetailsAddons],
        electricity: [...electricityKeyDetailsAddons],
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    onlineCredits: undefined,
    estimatesDialog: defaultEstimatesDialog(),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-pwc-affinity-variable/',
      },
    },
  },
};
